import React, { useEffect, useState } from 'react';
import {
    Box,
    Flex,
    Heading,
    useColorModeValue,
    Img,
} from '@chakra-ui/react';
import { redirect, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import CenteredAuth from 'layouts/auth/types/Centered';
import CInput from 'components/CInput';
import CButton from 'components/CButton';

function SystemConfiguration() {
    const { validateSystemConfiguration, isValidSystemConfiguration } = useAuth();

    const textColor = useColorModeValue('navy.700', 'white');

    const [validated, setValidated] = useState(false);
    const [password, setPassword] = useState('');

    const navigate = useNavigate();
    const location = useLocation();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setValidated(true);

        if (!password?.trim()) return;
        try {
            await validateSystemConfiguration(password);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (isValidSystemConfiguration) {
            if (location.pathname !== '/') {
                navigate(location.pathname);
            } else {
                navigate('/login');
            }
        }
    }, [isValidSystemConfiguration, navigate, location.pathname]);

    return (
        <CenteredAuth
            cardTop={{ base: '140px', md: '25vh' }}
            cardBottom={{ base: '50px', lg: 'auto' }}
            mx="0px"
        >
            <Flex
                maxW={{ base: '100%', md: 'max-content' }}
                w="100%"
                mx={{ base: 'auto', lg: '0px' }}
                me="auto"
                justifyContent="center"
                px={{ base: '20px', md: '0px' }}
                flexDirection="column"
            >
                <Flex
                    flexDirection="column"
                    justifyContent="center"
                    w={{ base: '100%', md: '420px' }}
                >
                    <Img
                        src='/logo8.png'
                        h='auto'
                        w="215px"
                        px='20px'
                        mb="52px"
                        alignSelf="center"
                    />
                </Flex>
                <Flex
                    zIndex="2"
                    direction="column"
                    w={{ base: '100%', md: '420px' }}
                    maxW="100%"
                    background="transparent"
                    borderRadius="15px"
                    mx={{ base: 'auto', lg: 'unset' }}
                    me="auto"
                    mb={{ base: '20px', md: 'auto' }}
                    mt={6}
                >
                    <form onSubmit={handleSubmit}>
                        <CInput
                            label="password"
                            type="text"
                            value={password}
                            onChange={(value) => setPassword(value)}
                            required={true}
                            validated={validated}
                            placeholder="password"
                        />
                        <CButton
                            mb="24px"
                            type="submit"
                        >
                            Submit
                        </CButton>
                    </form>
                </Flex>
            </Flex>
        </CenteredAuth>
    );
}

export default SystemConfiguration;